import React, { useEffect, useRef, useState } from "react";
import { Avatar, Modal, Popover } from "antd";
import ModalComponent from "../modal";
import { useNavigate } from "react-router-dom";
import UserIcon from "../../assets/images/user-icon.png";
import { AiOutlineSearch } from "react-icons/ai";
import styles from "./style.module.css";
import { useDispatch, useSelector } from "react-redux";
import {
  clearLocalStorage,
  convertTo12HourFormat,
  formatDate,
  formatMessage,
  getStudentChatDataForUserWithLastMessage,
} from "../../helper";
import { deleteUser } from "../../redux/slice/auth/authSlice";
import {
  HOME_URL,
  STUDENT_HOME_URL,
  STUDENT_PROFILE_SETTING_PAGE_URL,
  studentRouteConfig,
} from "../../constants";
import { BiLogOutCircle } from "react-icons/bi";
import { BiBell, BiEnvelope } from "react-icons/bi";

import Chat from "../chat/chat";
import { firestore } from "../../firebase/config";

import { NavLink } from "react-router-dom";

import { baseUrl } from "../../services/api";
import MessageCard from "../message-card";
import HeaderLogo from "../header-logo";
import { CgProfile } from "react-icons/cg";
import { FiSettings } from "react-icons/fi";
import { useLocation } from "react-router-dom";
import Menus from "../menus";
import { fetchStudentNotifications } from "../../services/student";
import HeaderSearch from "../header-search";

const StudentHeader = () => {
  const location = useLocation();
  const initLoadings = {
    notificationLoading: false
   }

  const loggedInUser = useSelector((state) => state.auth.user);
  const { meetings, listLoading } = useSelector((state) => state?.userMeetings);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const [activeItem, setActiveItem] = useState();
  const collapseRef = useRef(null);
  const [openSignUp, setOpenSignUp] = useState(false);
  const [openLogIn, setOpenLogIn] = useState(false);
  const [scrolling, setScrolling] = useState(false);

  const [messageLoading, setMessageLoading] = useState(true);
  const [messages, setMessages] = useState([]);
  const [messageSeen, setMessageSeen] = useState(false);

  const [notification, setNotification] = useState();

  const [loading, setLoading] = useState({...initLoadings})  

  
  const [notificationModal, setOpenNotificationModal] = useState({
    open: false,
    item: null
  })




  const [openMessageModal, setOpenMessageModal] = useState({
    itemDetail: "",
    open: false,
  });

  const content = (
    <div>
      <p className="cursor_pointer">{loggedInUser?.fullName}</p>
      <p
        onClick={() => handleMoveToStudentProfileSetting(STUDENT_HOME_URL)}
        className="cursor_pointer"
      >
        {" "}
        <CgProfile size={20} /> My Profile
      </p>
      <p
        onClick={() =>
          handleMoveToStudentProfileSetting(STUDENT_PROFILE_SETTING_PAGE_URL)
        }
        className="cursor_pointer"
      >
        {" "}
        <FiSettings size={20} /> Setting
      </p>
      <p onClick={() => handleLogOut()} className="cursor_pointer">
        <BiLogOutCircle size={20} /> Logout
      </p>
    </div>
  );

  const handleLoading = (name, value) => {
    let temp = {...loading}
    temp[name] = value;
    setLoading(temp);
   }

   const handleNotificationModal = (status, item) => {
    setOpenNotificationModal({
      open: status,
      item: item
    });
  };

  const renderProfilePicture = () => {
    return (
      <Avatar
        className="shadow-sm"
        src={
          <img
            width={30}
            src={
              loggedInUser?.profilePicture
                ? `${baseUrl}/${loggedInUser?.profilePicture}`
                : UserIcon
            }
            alt="avatar"
          />
        }
      />
    );
  };

  const getChatDataForUserWithLastMessage = async (userId, callback) => {
    try {
      const unsubscribeReceiver = firestore
        .collection("chats")
        .where("receiver_uuid", "==", userId)
        .onSnapshot((receiverSnapshot) => {
          const receiverChats = receiverSnapshot.docs.map((doc) => ({
            chatId: doc.id,
            lastMessage: doc.data().lastMessage,
          }));
          callback(receiverChats);
          // setMessageSeen(false);
          // setMessageLoading(false);
        });
      const unsubscribeSender = firestore
        .collection("chats")
        .where("sender_uuid", "==", userId)
        .onSnapshot((senderSnapshot) => {
          const senderChats = senderSnapshot.docs.map((doc) => ({
            chatId: doc.id,
            lastMessage: doc.data().lastMessage,
          }));
          callback(senderChats);
          // setMessageSeen(false);
          // setMessageLoading(false);
        });

      // Returning the unsubscribe functions in case you want to stop listening to changes later
      return {
        unsubscribeSender,
        unsubscribeReceiver,
      };
    } catch (error) {
      setMessageLoading(false);
      console.error("Error getting chat data for user:", error);
      throw error;
    }
  };

  const getNotifications = async (id) => {
  handleLoading("notificationLoading", true)
    try {
      let { status, data } = await fetchStudentNotifications(id);
      if (status === 200) {
        setNotification(data?.data);
      }
    } catch (error) {
      console.log("fetchNotifications Get", error);
    }
  handleLoading("notificationLoading", false)
  };

  useEffect(() => {
    // Example usage
    
    if (loggedInUser?.uuid) {
      getStudentChatDataForUserWithLastMessage(loggedInUser?.uuid, (chats) => {
        const sortedChats = chats.sort(
          (b, a) =>
            b.lastMessage.timestamp.seconds - a.lastMessage.timestamp.seconds
        );

        setMessages(sortedChats);
        setMessageSeen(false);
        setMessageLoading(false);
      });

    }

    //get notifications
    if(loggedInUser?.id){
      getNotifications(loggedInUser?.id)
    }


  }, [loggedInUser?.uuid]);



  const messageList = (list, loading) => {
    return (
      <div>
        {loading ? (
          <div>Loading...</div>
        ) : list?.length ? (
          <div className={`${styles.meetings}`}>
            <BiEnvelope size={25} className="me-2" />
            <b>Messages {`(${list?.length})`}</b>
            <hr />
            {list
              ?.slice()
              ?.reverse()
              ?.map((item) => {
                return (
                  <div
                    onClick={() => handleMessageModal2(true, item)}
                    key={item?.chatId}
                    className={` mb-2 cursor_pointer ${styles.itemWidth}`}
                  >
                    <MessageCard message={item?.lastMessage} />
                  </div>
                );
              })}
          </div>
        ) : (
          <div>No Messages to show</div>
        )}
      </div>
    );
  };

  const meetingList = (list, loading) => {
    return (
      <div>
        {loading ? (
          <div>Loading...</div>
        ) : list?.length ? (
          <div className={`${styles.meetings}`}>
            <BiBell size={25} className="me-2" />
            <b>Notifications {`(${list?.length})`}</b>
            <hr />
            {list
              ?.slice()
              ?.reverse()
              ?.map((item) => {
                return (
                  <div
                    onClick={() => handleMessageModal(true, item)}
                    key={item?.id}
                    className={` mb-2 cursor_pointer ${styles.itemWidth}`}
                  >
                    <div className="d-flex">
                      <div className={`${styles.singleMeeting} me-3 mt-2`}>
                        <BiBell color="white" size={20} />
                      </div>
                      <div className="flex-column d-flex">
                        <span>
                          Meeting with
                          <b>
                            <i> {item?.user?.fullName}</i>
                          </b>
                        </span>

                        <span style={{ color: "gray" }}>
                          {formatDate(item?.date)}
                        </span>
                        <span style={{ color: "gray" }}>
                          {convertTo12HourFormat(item?.startTime)} -{" "}
                          {convertTo12HourFormat(item?.endTime)}
                        </span>
                        <span>{formatMessage(item?.message, 5)}</span>
                      </div>
                    </div>

                    <hr />
                  </div>
                );
              })}
          </div>
        ) : (
          <div>No Notification to show</div>
        )}
      </div>
    );
  };

  
const notificationList = (list, loading) => {
  return (
    <div>
      {loading ? (
        <div>Loading...</div>
      ) : list?.length ? (
        <div className={`${styles.meetings}`}>
          <BiBell size={25} className="me-2" />
          <b>Notifications {`(${list?.length})`}</b>
          <hr />
          {list?.map((item) => {
              return (
                <div
                  onClick={() => handleNotificationModal(true, item)}
                  key={item?.id}
                  className={` mb-2 cursor_pointer ${styles.itemWidth}`}
                >
                  <div className="d-flex align-items-center">
                    <div className={`${styles.singleMeeting} me-3 mt-1`}>
                      <BiBell color="white" size={20} />
                    </div>
                    <div className="flex-column d-flex">
                      <span>
                        <b>
                          <i> {item?.content}</i>
                        </b>
                      </span>
{/* 
                      <span style={{ color: "gray" }}>
                        {formatDate(item?.date)}
                      </span>
                      <span style={{ color: "gray" }}>
                        {convertTo12HourFormat(item?.startTime)} -{" "}
                        {convertTo12HourFormat(item?.endTime)}
                      </span>
                      <span>{formatMessage(item?.message, 5)}</span> */}
                    </div>
                  </div>

                  <hr />
                </div>
              );
            })}
        </div>
      ) : (
        <div>No Notification to show</div>
      )}
    </div>
  );
};

  useEffect(() => {
    // Function to handle scroll events
    const handleScroll = () => {
      if (window.scrollY > 0) {
        // User has scrolled down, add classes
        setScrolling(true);
      } else {
        // User has scrolled to the top, remove classes
        setScrolling(false);
      }
    };

    // Add the scroll event listener when the component mounts
    window.addEventListener("scroll", handleScroll);

    // Remove the event listener when the component unmounts
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleMessageModal = (status, item) => {
    setOpenMessageModal({
      open: status,
      itemDetail: {
        ...item,
        uuid: item?.user?.uuid,
        fullName: item?.user?.fullName,
      },
    });
  };

  const handleMessageModal2 = (status, item) => {
    setOpenMessageModal({
      open: status,
      itemDetail: {
        ...item,
        id: item?.lastMessage?.receiverId,
        uuid:
          item?.lastMessage?.receiver_uuid === loggedInUser?.uuid
            ? item?.lastMessage?.sender_uuid
            : item?.lastMessage?.receiver_uuid,
        fullName:
          item?.lastMessage?.receiver_uuid === loggedInUser?.uuid
            ? item?.lastMessage?.senderName
            : item?.lastMessage?.receiverName,
      },
    });
  };

  const handleItemClick = (itemId) => {
    console.log("line 297");
    // setActiveItem(itemId);
    // Programmatically close the mobile menu
    if (collapseRef.current) {
      collapseRef.current.classList.remove("show");
    }
  };

  const handleSignUpModal = (status) => {
    setOpenSignUp(status);
  };

  const handleLogInModal = (status) => {
    setOpenLogIn(status);
  };

  const handleLogOut = () => {
    clearLocalStorage();
    dispatch(deleteUser());
    navigate(HOME_URL);
  };

  const handleMoveToStudentProfileSetting = (url) => {
    console.log("319");
    navigate(url);
  };

  return (
    <div style={{ backgroundColor: "#EFFBFF" }}>
      
  {/* notification modal */}
  <ModalComponent
        // zIndex={10000}
          // title={"Alert"}
          // open={notificationModal?.open}
          // onOk={() => handleNotificationModal(false, "")}
          title={"Notification"}
          show={notificationModal?.open}
          onCancel={() => handleNotificationModal(false, "")}
        >

                  <h6></h6>
                  <p className="my-4">{notificationModal?.item?.content}</p>



          {/* <div className="d-flex justify-content-end">
            <button
              onClick={() => handleNotificationModal(false, "")}
              disabled={loading}
              className="btn btn_outlined me-2"
            >
              Cancel
            </button> */}
            {/* <button
              onClick={() => handleNotificationModal(false, "")}
              disabled={loading}
              className="btn btn-primary btn_contained"
            >
              Proceed
            </button> */}
          <div className="d-flex justify-content-end">

            <button
              onClick={() => handleNotificationModal(false, "")}
              // disabled={loading}
              className="btn btn-primary btn_contained"
            >
              {/* {loading ? <Loader /> : "Proceed"} */}
              Ok
            </button>

            </div>

          {/* </div> */}
        </ModalComponent>




      <Modal
        // style={{
        //   top: 10,
        // }}
        maskClosable={false}
        width={700}
        footer={null}
        closable
        title=""
        open={openMessageModal?.open}
        onOk={() => handleMessageModal(false, "")}
        onCancel={() => handleMessageModal(false, "")}
        zIndex={1040}
      >
        <Chat receiver={openMessageModal?.itemDetail} />
      </Modal>

      {/* menu for small devices  star here */}
      <nav className="d-lg-none navbar navbar-expand-lg navbar-light ">
        <div className="container-fluid">
          {loggedInUser?.id ? (
            <div className="d-flex">
              <div style={{ cursor: "pointer" }} className={`mt-1`}>
                {meetings?.length ? (
                  <span className={styles.notification}></span>
                ) : (
                  <span className={styles.span}></span>
                )}
                <Popover
                  className={`cursor_pointer`}
                  // onClick={() => getAllTeacherMeetings(loggedInUser?.id)}
                  content={() => 
                    notificationList(notification, loading.notificationLoading)}
                  trigger="click"
                >
                  <BiBell size={25} />
                </Popover>
              </div>
              <div style={{ cursor: "pointer" }} className={`mt-1 me-2`}>
                {messages?.length && !messageSeen ? (
                  <span className={styles.notification2}></span>
                ) : (
                  <span className={styles.span}></span>
                )}
                <Popover
                  className={`cursor_pointer`}
                  onClick={() => setMessageSeen(true)}
                  content={() => messageList(messages, messageLoading)}
                  trigger="click"
                >
                  <BiEnvelope size={25} />
                </Popover>
              </div>
              <div style={{ cursor: "pointer" }}>
                <Popover
                  className="cursor_pointer"
                  content={content}
                  trigger="click"
                >
                  {renderProfilePicture()}
                </Popover>
              </div>
            </div>
          ) : (
            ""
          )}
          <HeaderLogo />
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div
            ref={collapseRef}
            className="collapse navbar-collapse"
            id="navbarSupportedContent"
          >
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              {location.pathname === HOME_URL ? <Menus /> : ""}
              <li style={{ fontSize: "12px" }} className="nav-item mt-2 mb-1">
                {/* <div className="d-flex bg-white me-2">
                  <input
                    type="search"
                    className="form-control fs_12 border-0 form_control_focus_box_shadow_none"
                    placeholder="Search"
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                  />
                  <AiOutlineSearch className={`${styles.searhIcon}`} />
                </div> */}
              </li>
              {!loggedInUser?.id ? (
                <>
                  <li
                    style={{ fontSize: "12px" }}
                    className="nav-item mt-1 mb-1"
                  >
                    <button
                      onClick={() => handleLogInModal(true)}
                      type="button"
                      className="btn btn-primary  btn-sm me-2 btn_contained_black"
                    >
                      Login
                    </button>
                  </li>
                  <li
                    style={{ fontSize: "12px" }}
                    className="nav-item mt-1 mb-1"
                  >
                    <button
                      onClick={() => handleSignUpModal(true)}
                      type="button"
                      className="btn btn-primary  btn-sm me-2 btn_contained_black"
                    >
                      Sign Up
                    </button>
                  </li>
                </>
              ) : (
                ""
              )}
              {/* <li style={{ fontSize: "12px" }} className="nav-item mt-1 mb-1">
                <button
                  type="button"
                  className="btn btn-primary text-uppercase btn-sm me-2 btn_contained_black"
                >
                  BECOME A TEACHER
                </button>
              </li> */}

              {location.pathname !== HOME_URL &&
                studentRouteConfig?.map((item) => {
                  return (
                    <li
                      style={{ fontSize: "15px" }}
                      key={item?.name}
                      className="nav-item"
                      onClick={() => handleItemClick(1)} //pass constant as ItemID, Don't need now
                    >
                      <NavLink
                        end
                        className={({ isActive }) =>
                          isActive
                            ? `${styles.nav_link} ${styles.active} nav-link fw-medium`
                            : `${styles.nav_link} nav-link`
                        }
                        aria-current="page"
                        to={item.path}
                      >
                        {<item.icon size={25} />}
                        {item.name}
                      </NavLink>
                      {/* <Link
                      className={`nav-link text-black ${
                        activeItem === item.id ? "fw-medium" : ""
                      }`}
                      aria-current="page"
                      to={item?.link}
                    >
                      {item?.name}
                    </Link> */}
                    </li>
                  );
                })}
            </ul>
          </div>
        </div>
      </nav>

      {/* menu for small devices end here */}

      {/* menu for large devices start here */}

      <div
        className={`d-none d-lg-block pe-5 px-5
        
        `}
        style={{ backgroundColor: "#EFFBFF" }}
      >
        <div>
          <div
            style={{ paddingLeft: "22px", paddingRight: "28px" }}
            className="justify-content-between d-flex  pb-2 pt-4"
          >
            <HeaderLogo />

            {/* changed */}
            <nav className={`navbar navbar-expand-lg navbar-light`}>
              {/* <div className="container-fluid pe-3 px-3"> */}
              <div
                className="collapse navbar-collapse justify-content-start"
                id="navbarSupportedContent"
              >
                <ul
                  className="navbar-nav"
                  // style={{ margin: "0 auto" }}
                  style={{ margin: "-5px 560px -10px 0px" }}
                >
                  <Menus />
                </ul>
              </div>
              {/* </div> */}
            </nav>

            <div className="justify-content-between d-flex">
              {/* header search input */}
              {/* {location.pathname === HOME_URL ? <HeaderSearch /> : ""} */}
              {!loggedInUser?.id ? (
                <>
                  <button
                    onClick={() => handleLogInModal(true)}
                    type="button"
                    className="btn btn-primary text-uppercase btn-sm me-2 btn_contained_black"
                  >
                    Login
                  </button>
                  <button
                    onClick={() => handleSignUpModal(true)}
                    type="button"
                    className="btn btn-primary text-uppercase btn-sm me-2 btn_contained_black"
                  >
                    Sign Up
                  </button>
                </>
              ) : (
                ""
              )}
              {/* <button
              type="button"
              className="btn btn-primary text-uppercase btn-sm me-2 btn_contained_black"
            >
              BECOME A TEACHER
            </button> */}
              {loggedInUser?.id ? (
                <div className="d-flex align-items-center">
                  <div style={{ cursor: "pointer" }}>
                    {meetings?.length ? (
                      <span className={styles.notification}></span>
                    ) : (
                      <span className={styles.span}></span>
                    )}
                    <Popover
                      className={`cursor_pointer`}
                      // onClick={() => getAllTeacherMeetings(loggedInUser?.id)}
                      content={() => 
                        notificationList(notification, loading.notificationLoading)}
                      trigger="click"
                    >
                      <BiBell size={25} />
                    </Popover>
                  </div>
                  <div style={{ cursor: "pointer" }} className={`me-2`}>
                    {messages?.length && !messageSeen ? (
                      <span className={styles.notification2}></span>
                    ) : (
                      <span className={styles.span}></span>
                    )}
                    <Popover
                      className={`cursor_pointer`}
                      // onClick={() => getAllTeacherMeetings(loggedInUser?.id)}
                      content={() => messageList(messages, messageLoading)}
                      trigger="click"
                      onClick={() => setMessageSeen(true)}
                    >
                      <BiEnvelope size={25} />
                    </Popover>
                  </div>
                  <div style={{ cursor: "pointer" }}>
                    <Popover
                      className="cursor_pointer"
                      content={content}
                      trigger="click"
                    >
                      {renderProfilePicture()}
                    </Popover>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
          <ul
            className="pt-2 navbar-nav mb-2 mb-lg-0 d-flex flex-row justify-content-center"
            style={{ gap: "11px" }}
          >
            {/* {location.pathname === HOME_URL ? <Menus /> : ""} */}
          </ul>
        </div>

        <nav
          className={`navbar navbar-expand-lg navbar-light
           ${scrolling ? `fixed-top bg-white shadow` : ""}
          `}
        >
          <div className="container-fluid pe-3 px-3">
            <div
              className="collapse navbar-collapse justify-content-between"
              id="navbarSupportedContent"
            >
              {scrolling ? <HeaderLogo /> : ""}
              <ul
                className="navbar-nav mb-2 mb-lg-0"
                // style={{ margin: "0 auto" }}
              >
                {scrolling && loggedInUser?.id ? (
                  <>
                    <div
                      className="d-flex"
                      style={{ margin: "0px 720px 0px 0px" }}
                    >
                      {/* {location.pathname === HOME_URL ? <Menus /> : ""} */}
                      {<Menus />}
                    </div>

                    <li style={{ fontSize: "11px" }} className="nav-item mt-1">
                      {meetings?.length ? (
                        <span className={styles.notification}></span>
                      ) : (
                        <span className={styles.span}></span>
                      )}
                      <Popover
                        className={`cursor_pointer`}
                        // onClick={() => getAllTeacherMeetings(loggedInUser?.id)}
                        content={() => 
                          notificationList(notification, loading.notificationLoading)}
                        trigger="click"
                      >
                        <BiBell size={25} />
                      </Popover>
                    </li>
                    <li
                      style={{ fontSize: "11px" }}
                      className="nav-item mt-1 me-2"
                    >
                      {messages?.length && !messageSeen ? (
                        <span className={styles.notification2}></span>
                      ) : (
                        <span className={styles.span}></span>
                      )}
                      <Popover
                        className={`cursor_pointer`}
                        // onClick={() => getAllTeacherMeetings(loggedInUser?.id)}
                        content={() => messageList(messages, messageLoading)}
                        trigger="click"
                        onClick={() => setMessageSeen(true)}
                      >
                        <BiEnvelope size={25} />
                      </Popover>
                    </li>
                    <li style={{ fontSize: "11px" }} className="nav-item">
                      {" "}
                      <Popover
                        className="cursor_pointer"
                        content={content}
                        trigger="click"
                      >
                        {renderProfilePicture()}
                      </Popover>
                    </li>
                  </>
                ) : (
                  ""
                )}
              </ul>
            </div>
          </div>
        </nav>
      </div>
      {/* menu for large devices end here */}
    </div>
  );
};

export default StudentHeader;
